import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

let state =  require('../store/index').default.state
import _this from '../main.js'

// let newApj = 'http://114.100.249.32:8088'// 临泉版本
let newApj = 'https://api-test.sheepboss.com'// 壹号圈版本

class BaseModule {
  userSmsSend (data) {//获取验证码
		return this.postFn(newApj + '/api/user/sms/send', data)
  }
  userLogin (data) {//用户登录
		return this.postFn(newApj + '/api/user/login', data)
  }
  userRegister (data) {//用户注册
		return this.postFn(newApj + '/api/user/register', data)
  }
  userProfile (data) {//基本信息
		return this.getFn(newApj + '/api/user/profile', data)
  }
  userPasswordEdit (data) {//修改密码
		return this.postFn(newApj + '/api/user/password/edit', data)
  }
  userLogout (data) {//登出
		return this.postFn(newApj + '/api/user/logout', data)
  }
  userForgotPassword (data) {//忘记密码
		return this.postFn(newApj + '/api/user/forgot/password', data)
  }
  userQrcodeGetcode (data) {//获取登录二维码
		return this.getFn(newApj + '/api/user/qrcode/getcode', data)
  }
  userQrcodeStatus (data) {//二维码状态
		return this.postFn(newApj + '/api/user/qrcode/status', data)
  }
  userCompanyLinkListAvailable (data) {//可查看的主体
		return this.getFn(newApj + '/api/user/company/link/list/available', data)
  }
  userChangeCompany (data) {//切换主体
		return this.postFn(newApj + '/api/user/change/company', data)
  }
  userAliToken (data) {//阿里云accessToken
		return this.postFn(newApj + '/api/user/ali/token', data)
  }
  userStatisticsPie (data) {//饼图
		return this.getFn(newApj + '/api/user/statistics/pie', data)
  }
  userStatisticsLine (data) {//折线图
		return this.getFn(newApj + '/api/user/statistics/line', data)
  }
  userStatisticsLineTrend (data) {//折线图-存栏量12个月预测
		return this.getFn(newApj + '/api/user/statistics/line/trend', data)
  }
  userCompanyInfoSave (data) {//完善企业信息
		return this.postFn(newApj + '/api/user/company/info/save', data)
  }
  userCompanyInfo (data) {//获取企业信息
		return this.getFn(newApj + '/api/user/company/info', data)
  }
  userCompanyInfoEdit (data) {//修改企业信息
		return this.postFn(newApj + '/api/user/company/info/edit', data)
  }
  areaProvinceList (data) {//行政区划省
		return this.getFn(newApj + '/api/area/province/list', data)
  }
  areaCityList (data) {//行政区划市
		return this.getFn(newApj + '/api/area/city/list', data)
  }
  areaCountyList (data) {//行政区划县区
		return this.getFn(newApj + '/api/area/county/list', data)
  }
  areaTownList (data) {//行政区划乡镇
		return this.getFn(newApj + '/api/area/town/list', data)
  }
  photoUpload (data) {//图片上传
		return this.uploadFn(newApj + '/api/photo/upload', data)
  }
  fileUpload (data) {//文件上传
		return this.uploadFn(newApj + '/api/file/upload', data)
  }
  userSheepImport (data) {//批量导入
		return this.uploadFn(newApj + '/api/user/sheep/import', data)
  }
  userFarmListAvailable (data) {//场设置下拉列表
		return this.getFn(newApj + '/api/user/farm/list/available', data)
  }
  userFarmEarTagPrefix (data) {//耳标前缀
		return this.getFn(newApj + '/api/user/farm/ear/tag/prefix', data)
  }
  userFarmList (data) {//场设置列表查询
		return this.getFn(newApj + '/api/user/farm/list', data)
  }
  userFarmSave (data) {//场设置新增修改
		return this.postFn(newApj + '/api/user/farm/save', data)
  }
  userFarmDelete (data) {//场设置删除
		return this.postFn(newApj + '/api/user/farm/delete', data)
  }
  userPartitionListAvailable (data) {//区设置下拉列表
		return this.getFn(newApj + '/api/user/partition/list/available', data)
  }
  userPartitionList (data) {//区设置列表查询
		return this.getFn(newApj + '/api/user/partition/list', data)
  }
  userPartitionSave (data) {//区设置新增修改
		return this.postFn(newApj + '/api/user/partition/save', data)
  }
  userPartitionDelete (data) {//区设置删除
		return this.postFn(newApj + '/api/user/partition/delete', data)
  }
  userGroupListAvailable (data) {//群设置下拉列表
		return this.getFn(newApj + '/api/user/group/list/available', data)
  }
  userGroupListAvailable (data) {//群设置列表查询
		return this.getFn(newApj + '/api/user/group/list/available', data)
  }
  userGroupDetail (data) {//群设置已选择群
		return this.getFn(newApj + '/api/user/group/detail', data)
  }
  userGroupSave (data) {//群设置勾选群
		return this.postFn(newApj + '/api/user/group/save', data)
  }
  userHouseListAvailable (data) {//舍设置下拉列表
		return this.getFn(newApj + '/api/user/house/list/available', data)
  }
  userHouseList (data) {//舍设置列表查询
		return this.getFn(newApj + '/api/user/house/list', data)
  }
  userHouseSave (data) {//舍设置新增修改
		return this.postFn(newApj + '/api/user/house/save', data)
  }
  userHouseDelete (data) {//舍设置删除
		return this.postFn(newApj + '/api/user/house/delete', data)
  }
  userHouseQrcode (data) {//舍二维码
		return this.getFn(newApj + '/api/user/house/qrcode', data)
  }
  userCompanyLinkListDown (data) {//关联组织列表子公司
		return this.getFn(newApj + '/api/user/company/link/list/down', data)
  }
  userCompanyLinkListUp (data) {//关联组织列表上级组织
		return this.getFn(newApj + '/api/user/company/link/list/up', data)
  }
  userCompanyLinkSave (data) {//关联组织新增修改
		return this.postFn(newApj + '/api/user/company/link/save', data)
  }
  userCompanyLinkDelete (data) {//关联组织删除
		return this.postFn(newApj + '/api/user/company/link/delete', data)
  }
  userCompanyLinkAccept (data) {//关联组织同意关联
		return this.postFn(newApj + '/api/user/company/link/accept', data)
  }
  userCompanyLinkCancel (data) {//关联组织取消关联
		return this.postFn(newApj + '/api/user/company/link/cancel', data)
  }
  userDeptTree (data) {//部门管理部门树
		return this.getFn(newApj + '/api/user/dept/tree', data)
  }
  userDeptSave (data) {//部门管理新增修改
		return this.postFn(newApj + '/api/user/dept/save', data)
  }
  userDeptDelete (data) {//部门管理删除
		return this.postFn(newApj + '/api/user/dept/delete', data)
  }
  userUserListAvailable (data) {//用户管理下拉列表
		return this.getFn(newApj + '/api/user/user/list/available', data)
  }
  userUserList (data) {//用户管理列表查询
		return this.getFn(newApj + '/api/user/user/list', data)
  }
  userUserSave (data) {//用户管理新增修改
		return this.postFn(newApj + '/api/user/user/save', data)
  }
  userUserDelete (data) {//用户管理删除
		return this.postFn(newApj + '/api/user/user/delete', data)
  }
  userRoleListAvailable (data) {//角色管理下拉列表
		return this.getFn(newApj + '/api/user/role/list/available', data)
  }
  userRoleList (data) {//角色管理列表查询
		return this.getFn(newApj + '/api/user/role/list', data)
  }
  userRoleSave (data) {//角色管理新增修改
		return this.postFn(newApj + '/api/user/role/save', data)
  }
  userRoleDelete (data) {//角色管理删除
		return this.postFn(newApj + '/api/user/role/delete', data)
  }
  userRolePermission (data) {//角色管理权限设置
		return this.postFn(newApj + '/api/user/role/permission', data)
  }
  userDictTypeList (data) {//数据字典字典类别
		return this.getFn(newApj + '/api/user/dict/type/list', data)
  }
  userDictList (data) {//数据字典字典列表
		return this.getFn(newApj + '/api/user/dict/list', data)
  }
  userDictSave (data) {//数据字典新增修改
		return this.postFn(newApj + '/api/user/dict/save', data)
  }
  userDictDelete (data) {//数据字典删除
		return this.postFn(newApj + '/api/user/dict/delete', data)
  }
  companyListKeyword (data) {//下拉列表
		return this.getFn(newApj + '/api/company/list/keyword', data)
  }
  userPenListAvailable (data) {//圈管理下拉列表
		return this.getFn(newApj + '/api/user/pen/list/available', data)
  }
  userPenList (data) {//圈管理列表查询
		return this.getFn(newApj + '/api/user/pen/list', data)
  }
  userPenSet (data) {//圈管理圈设置
		return this.postFn(newApj + '/api/user/pen/set', data)
  }
  userSheepListByPen (data) {//圈管理圈羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/pen', data)
  }
  userSheepDelete (data) {//圈管理删除羊
		return this.postFn(newApj + '/api/user/sheep/delete', data)
  }
  userManagFarmSumList (data) {//养殖管理场列表
		return this.getFn(newApj + '/api/user/manage/farm/sum/list', data)
  }
  userManagFarmHouseList (data) {//养殖管理舍列表
		return this.getFn(newApj + '/api/user/manage/farm/house/list', data)
  }
  userManagFarmDeliverySum (data) {//养殖管理羔羊/待产/保育羊数量统计
		return this.getFn(newApj + '/api/user/manage/farm/delivery/sum', data)
  }
  userSheepListByHouse (data) {//养殖管理羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/house', data)
  }
  userManageHousePenList (data) {//养殖管理圈列表
		return this.getFn(newApj + '/api/user/manage/house/pen/list', data)
  }
  userSheepArchives (data) {//羊档案
		return this.getFn(newApj + '/api/user/sheep/archives', data)
  }
  userSheepSave (data) {//新增修改羊
		return this.postFn(newApj + '/api/user/sheep/save', data)
  }
  userSheepListByCode (data) {//通过code查询羊
		return this.getFn(newApj + '/api/user/sheep/list/by/code', data)
  }
  userSheepListByEarTagCode (data) {//通过耳标查询羊
		return this.getFn(newApj + '/api/user/sheep/list/by/earTagCode', data)
  }
  userEarTagEdit (data) {//更换|佩戴耳标
		return this.postFn(newApj + '/api/user/ear/tag/edit', data)
  }
  userEarTagListForSheep (data) {//更换|佩戴耳标记录
		return this.getFn(newApj + '/api/user/ear/tag/list/for/sheep', data)
  }
  userSheepListByPen (data) {//圈-羊列表
		return this.getFn(newApj + '/api/user/sheep/list/by/pen', data)
  }
  userManageHouseSum (data) {//舍统计
		return this.getFn(newApj + '/api/user/manage/house/sum', data)
  }
  userDeviceHouseInfo (data) {//甲烷、氨气、温湿度
		return this.getFn(newApj + '/api/user/device/house/info', data)
  }
  userGroupChangePenList (data) {//群调整历史记录列表
		return this.getFn(newApj + '/api/user/group/change/pen/list', data)
  }
  userGroupChangePenSave (data) {//群调整新增
		return this.postFn(newApj + '/api/user/group/change/pen/save', data)
  }
  userGroupChangeList (data) {//转群列表查询
		return this.getFn(newApj + '/api/user/group/change/list', data)
  }
  userGroupChangeSave (data) {//转群新增修改
		return this.postFn(newApj + '/api/user/group/change/save', data)
  }
  userSaleList (data) {//销售列表查询
		return this.getFn(newApj + '/api/user/sale/list', data)
  }
  userSaleSave (data) {//销售新增修改
		return this.postFn(newApj + '/api/user/sale/save', data)
  }
  userDeathList (data) {//死亡列表查询
		return this.getFn(newApj + '/api/user/death/list', data)
  }
  userDeathSave (data) {//死亡新增修改
		return this.postFn(newApj + '/api/user/death/save', data)
  }
  userMatingList (data) {//配种列表查询
		return this.getFn(newApj + '/api/user/mating/list', data)
  }
  userMatingSave (data) {//配种新增修改
		return this.postFn(newApj + '/api/user/mating/save', data)
  }
  userSpermListAvailable (data) {//可用的精液列表
		return this.getFn(newApj + '/api/user/sperm/list/available', data)
  }
  userSelectCompany (data) {//选择主体
		return this.postFn(newApj + '/api/user/select/company', data)
  }
  userPsiCategoryTreeAvailable (data) {//商品分类(可用树结构(下拉选择使用))
		return this.getFn(newApj + '/api/user/psi/category/tree/available', data)
  }
  userPsiCategoryTreeSecondAvailable (data) {//商品分类(获取二级分类(下拉选择使用))
		return this.getFn(newApj + '/api/user/psi/category/tree/second/available', data)
  }
  userPsiCategoryTree (data) {//商品分类(树结构)
		return this.getFn(newApj + '/api/user/psi/category/tree', data)
  }
  userPsiCategoryFirstSave (data) {//商品分类(一级新增修改)
		return this.postFn(newApj + '/api/user/psi/category/first/save', data)
  }
  userPsiCategorySecondSave (data) {//商品分类(二级新增修改)
		return this.postFn(newApj + '/api/user/psi/category/second/save', data)
  }
  userPsiCategoryDelete (data) {//商品分类(删除)
		return this.postFn(newApj + '/api/user/psi/category/delete', data)
  }
  userPsiGoodsList (data) {//商品管理(列表)
		return this.getFn(newApj + '/api/user/psi/goods/list', data)
  }
  userPsiGoodsSave (data) {//商品管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/goods/save', data)
  }
  userPsiGoodsDelete (data) {//商品管理(删除)
		return this.postFn(newApj + '/api/user/psi/goods/delete', data)
  }
  userPsiGoodsSupplyCycleList (data) {//商品管理(供货周期-列表)
		return this.getFn(newApj + '/api/user/psi/goods/supply/cycle/list', data)
  }
  userPsiGoodsSupplyCycleSave(data) {//商品管理(供货周期-新增修改)
		return this.postFn(newApj + '/api/user/psi/goods/supply/cycle/save', data)
  }
  userPsiGoodsSupplyCycleDelete(data) {//商品管理(供货周期-删除)
		return this.postFn(newApj + '/api/user/psi/goods/supply/cycle/delete', data)
  }
  userPsiSupplierListAvailable(data) {//供应商管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/supplier/list/available', data)
  }
  userPsiSupplierList(data) {//供应商管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/supplier/list', data)
  }
  userPsiSupplierSave(data) {//供应商管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/supplier/save', data)
  }
  userPsiSupplierDelete(data) {//供应商管理(删除)
		return this.postFn(newApj + '/api/user/psi/supplier/delete', data)
  }
  userPsiCustomListAvailable(data) {//客户管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/custom/list/available', data)
  }
  userPsiCustomList(data) {//客户管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/custom/list', data)
  }
  userPsiCustomSave(data) {//客户管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/custom/save', data)
  }
  userPsiCustomDelete(data) {//客户管理(删除)
		return this.postFn(newApj + '/api/user/psi/custom/delete', data)
  }
  userPsiHouseListAvailable(data) {//库房管理(下拉列表)
		return this.getFn(newApj + '/api/user/psi/house/list/available', data)
  }
  userPsiHouseList(data) {//库房管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/list', data)
  }
  userPsiHouseSave(data) {//库房管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/save', data)
  }
  userPsiHouseDelete(data) {//库房管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/delete', data)
  }
  userPsiHouseShelfList(data) {//货架(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/shelf/list', data)
  }
  userPsiHouseShelfSave(data) {//货架(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/shelf/save', data)
  }
  userPsiHouseShelfDelete(data) {//货架(删除)
		return this.postFn(newApj + '/api/user/psi/house/shelf/delete', data)
  }
  userPsiStockReport1(data) {//统计报表(采购统计)
		return this.getFn(newApj + '/api/user/psi/stock/report1', data)
  }
  userPsiStockReport2(data) {//统计报表(销售统计)
		return this.getFn(newApj + '/api/user/psi/stock/report2', data)
  }
  userPsiStockReport3(data) {//统计报表(入库明细)
		return this.getFn(newApj + '/api/user/psi/stock/report3', data)
  }
  userPsiStockReport4(data) {//统计报表(出库明细)
		return this.getFn(newApj + '/api/user/psi/stock/report4', data)
  }
  userPsiStockReport5(data) {//统计报表(调拨明细)
		return this.getFn(newApj + '/api/user/psi/stock/report5', data)
  }
  userPsiStockReport6(data) {//统计报表(入库汇总)
		return this.getFn(newApj + '/api/user/psi/stock/report6', data)
  }
  userPsiStockReport7(data) {//统计报表(出库汇总)
		return this.getFn(newApj + '/api/user/psi/stock/report7', data)
  }
  userPsiStockList(data) {//库存查询|分析(列表查询)
		return this.getFn(newApj + '/api/user/psi/stock/list', data)
  }
  userPsiStockImport(data) {//库存查询|分析(导入盘库文件)
		return this.postFn(newApj + '/api/user/psi/stock/import', data)
  }
  userPsiPurchaseOrderList(data) {//原采购订单(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/order/list', data)
  }
  userPsiPurchaseOrderDetail(data) {//原采购订单(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/order/detail', data)
  }
  userPsiPurchaseOrderSave(data) {//原采购订单(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/order/save', data)
  }
  userPsiPurchaseOrderDelete(data) {//原采购订单(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/order/delete', data)
  }
  userPsiPurchaseOrderAudit(data) {//原采购订单(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/order/audit', data)
  }
  userPsiPurchaseOrderAuditEdit(data) {//原采购订单(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/order/audit/edit', data)
  }
  userPsiPurchaseHouseInList(data) {//采购入库(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/house/in/list', data)
  }
  userPsiPurchaseHouseInDetail(data) {//采购入库(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/house/in/detail', data)
  }
  userPsiPurchaseHouseInSave(data) {//采购入库(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/save', data)
  }
  userPsiPurchaseHouseInDelete(data) {//采购入库(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/delete', data)
  }
  userPsiPurchaseHouseInAudit(data) {//采购入库(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/audit', data)
  }
  userPsiPurchaseHouseInAuditEdit(data) {//采购入库(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/in/audit/edit', data)
  }
  userPsiPurchaseHouseOutList(data) {//原采购退货(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/house/out/list', data)
  }
  userPsiPurchaseHouseOutDetail(data) {//原采购退货(详情)
		return this.getFn(newApj + '/api/user/psi/purchase/house/out/detail', data)
  }
  userPsiPurchaseHouseOutSave(data) {//原采购退货(新增修改)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/save', data)
  }
  userPsiPurchaseHouseOutDelete(data) {//原采购退货(删除)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/delete', data)
  }
  userPsiPurchaseHouseOutAudit(data) {//原采购退货(审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/audit', data)
  }
  userPsiPurchaseHouseOutAuditEdit(data) {//原采购退货(反审核)
		return this.postFn(newApj + '/api/user/psi/purchase/house/out/audit/edit', data)
  }
  userPsiPurchaseCheckList(data) {//应付款审核(列表查询)
		return this.getFn(newApj + '/api/user/psi/purchase/check/list', data)
  }
  userPsiPurchaseCheckSave(data) {//应付款审核(核销)
		return this.postFn(newApj + '/api/user/psi/purchase/check/save', data)
  }
  userPsiSaleOrderList(data) {//原销售订单(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/order/list', data)
  }
  userPsiSaleOrderDetail(data) {//原销售订单(详情)
		return this.getFn(newApj + '/api/user/psi/sale/order/detail', data)
  }
  userPsiSaleOrderSave(data) {//原销售订单(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/order/save', data)
  }
  userPsiSaleOrderDelete(data) {//原销售订单(删除)
		return this.postFn(newApj + '/api/user/psi/sale/order/delete', data)
  }
  userPsiSaleOrderAudit(data) {//原销售订单(审核)
		return this.postFn(newApj + '/api/user/psi/sale/order/audit', data)
  }
  userPsiSaleOrderAuditEdit(data) {//原销售订单(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/order/audit/edit', data)
  }
  userPsiSaleHouseOutList(data) {//销售出库(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/house/out/list', data)
  }
  userPsiSaleHouseOutDetail(data) {//销售出库(详情)
		return this.getFn(newApj + '/api/user/psi/sale/house/out/detail', data)
  }
  userPsiSaleHouseOutSave(data) {//销售出库(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/save', data)
  }
  userPsiSaleHouseOutDelete(data) {//销售出库(删除)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/delete', data)
  }
  userPsiSaleHouseOutAudit(data) {//销售出库(审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/audit', data)
  }
  userPsiSaleHouseOutAuditEdit(data) {//销售出库(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/out/audit/edit', data)
  }
  userPsiSaleHouseInList(data) {//销售退货(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/house/in/list', data)
  }
  userPsiSaleHouseInDetail(data) {//销售退货(详情)
		return this.getFn(newApj + '/api/user/psi/sale/house/in/detail', data)
  }
  userPsiSaleHouseInSave(data) {//销售退货(新增修改)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/save', data)
  }
  userPsiSaleHouseInDelete(data) {//销售退货(删除)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/delete', data)
  }
  userPsiSaleHouseInAudit(data) {//销售退货(审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/audit', data)
  }
  userPsiSaleHouseInAuditEdit(data) {//销售退货(反审核)
		return this.postFn(newApj + '/api/user/psi/sale/house/in/audit/edit', data)
  }
  userPsiSaleCheckList(data) {//应收款审核(列表查询)
		return this.getFn(newApj + '/api/user/psi/sale/check/list', data)
  }
  userPsiSaleCheckSave(data) {//应收款审核(核销)
		return this.postFn(newApj + '/api/user/psi/sale/check/save', data)
  }
  userPsiHouseInList(data) {//原入库管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/in/list', data)
  }
  userPsiHouseInDetail(data) {//原入库管理(详情)
		return this.getFn(newApj + '/api/user/psi/house/in/detail', data)
  }
  userPsiHouseInSave(data) {//原入库管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/in/save', data)
  }
  userPsiHouseInDelete(data) {//原入库管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/in/delete', data)
  }
  userPsiHouseInAudit(data) {//原入库管理(审核)
		return this.postFn(newApj + '/api/user/psi/house/in/audit', data)
  }
  userPsiHouseInAuditEdit(data) {//原入库管理(反审核)
		return this.postFn(newApj + '/api/user/psi/house/in/audit/edit', data)
  }
  userPsiHouseOutList(data) {//原出库管理(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/out/list', data)
  }
  userPsiHouseOutDetail(data) {//原出库管理(详情)
		return this.getFn(newApj + '/api/user/psi/house/out/detail', data)
  }
  userPsiHouseOutSave(data) {//原出库管理(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/out/save', data)
  }
  userPsiHouseOutDelete(data) {//原出库管理(删除)
		return this.postFn(newApj + '/api/user/psi/house/out/delete', data)
  }
  userPsiHouseOutAudit(data) {//原出库管理(审核)
		return this.postFn(newApj + '/api/user/psi/house/out/audit', data)
  }
  userPsiHouseOutAuditEdit(data) {//原出库管理(反审核)
		return this.postFn(newApj + '/api/user/psi/house/out/audit/edit', data)
  }
  userPsiHouseExchangeList(data) {//调拨出库(列表查询)
		return this.getFn(newApj + '/api/user/psi/house/exchange/list', data)
  }
  userPsiHouseExchangeDetail(data) {//调拨出库(详情)
		return this.getFn(newApj + '/api/user/psi/house/exchange/detail', data)
  }
  userPsiHouseExchangeSave(data) {//调拨出库(新增修改)
		return this.postFn(newApj + '/api/user/psi/house/exchange/save', data)
  }
  userPsiHouseExchangeDelete(data) {//调拨出库(删除)
		return this.postFn(newApj + '/api/user/psi/house/exchange/delete', data)
  }
  userPsiHouseExchangeAudit(data) {//调拨出库(审核)
		return this.postFn(newApj + '/api/user/psi/house/exchange/audit', data)
  }
  userPsiHouseExchangeAuditEdit(data) {//调拨出库(反审核)
		return this.postFn(newApj + '/api/user/psi/house/exchange/audit/edit', data)
  }
  userPsiStockCheckList(data) {//盘盈盘亏(列表查询)
		return this.getFn(newApj + '/api/user/psi/stock/check/list', data)
  }
  userPsiStockCheckDetail(data) {//盘盈盘亏(详情)
		return this.getFn(newApj + '/api/user/psi/stock/check/detail', data)
  }
  userPsiStockCheckSave(data) {//盘盈盘亏(新增修改)
		return this.postFn(newApj + '/api/user/psi/stock/check/save', data)
  }
  userPsiStockCheckDelete(data) {//盘盈盘亏(删除)
		return this.postFn(newApj + '/api/user/psi/stock/check/delete', data)
  }
  userPsiStockCheckAudit(data) {//盘盈盘亏(审核)
		return this.postFn(newApj + '/api/user/psi/stock/check/audit', data)
  }
  userPsiStockCheckAuditEdit(data) {//盘盈盘亏(反审核)
		return this.postFn(newApj + '/api/user/psi/stock/check/audit/edit', data)
  }
  userPsiGoodsListAvailable1(data) {//添加商品(列表查询（与场、仓库无关）：采购订单、采购入库单、退货入库单、库存盘盈单、库存盘亏单)
		return this.getFn(newApj + '/api/user/psi/goods/list/available1', data)
  }
  userPsiGoodsListAvailable2(data) {//添加商品(列表查询（与场、仓库有关））：原采购退货单、销售单、调拨单)
		return this.getFn(newApj + '/api/user/psi/goods/list/available2', data)
  }
  userPsiGoodsListImport1(data) {//添加商品(导入文件（与场、仓库无关））：采购订单、采购入库单、退货入库单、库存盘盈单、库存盘亏单)
		return this.postFn(newApj + '/api/user/psi/goods/list/import1', data)
  }
  userPsiGoodsListImport2(data) {//添加商品(导入文件（与场、仓库有关））：原采购退货单、销售单、调拨单)
		return this.postFn(newApj + '/api/user/psi/goods/list/import2', data)
  }
  userBreedPlanListPen(data) {//添加圈列表(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/list/pen', data)
  }
  userBreedPlanList(data) {//列表查询(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/list', data)
  }
  userBreedPlanDetail(data) {//详情(养殖计划)
		return this.getFn(newApj + '/api/user/breed/plan/detail', data)
  }
  userBreedPlanSave(data) {//新增修改(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/save', data)
  }
  userBreedPlanDelete(data) {//删除(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/delete', data)
  }
  userBreedPlanAudit(data) {//审核(养殖计划)
		return this.postFn(newApj + '/api/user/breed/plan/audit', data)
  }
  userStatisticsLaunch(data) {//列表查询(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch', data)
  }
  userStatisticsLaunchDetail(data) {//查看详情(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch/detail', data)
  }
  userStatisticsLaunchDetailPen(data) {//查看详情-出栏日期(出栏计划)
		return this.getFn(newApj + '/api/user/statistics/launch/detail/pen', data)
  }
  userStatisticsLambing(data) {//列表查询(产羔计划)
		return this.getFn(newApj + '/api/user/statistics/lambing', data)
  }
  userStatisticsLambingSave(data) {//选种选育数保存(产羔计划)
		return this.postFn(newApj + '/api/user/statistics/lambing/save', data)
  }
  userBreedTaskListPenByTaskId (data) {//圈列表-通过任务id查询
		return this.getFn(newApj + '/api/user/breed/task/list/pen/by/task/id', data)
	}
	userBreedTaskListPenByTaskType (data) {//圈列表-通过任务类别查询
		return this.getFn(newApj + '/api/user/breed/task/list/pen/by/task/type', data)
	}
	userBreedTaskListPenAll (data) {//圈列表-非以上10个类别的
		return this.getFn(newApj + '/api/user/breed/task/list/pen/all', data)
	}
  userBreedStandardListAvailable(data) {//下拉列表(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/list/available', data)
  }
  userBreedStandardList(data) {//列表查询(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/list', data)
  }
  userBreedStandardDetail(data) {//详情(养殖标准)
		return this.getFn(newApj + '/api/user/breed/standard/detail', data)
  }
  userBreedStandardSave(data) {//新增修改(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/save', data)
  }
  userBreedStandardDelete(data) {//删除(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/delete', data)
  }
  userBreedStandardAudit(data) {//审核(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/audit', data)
  }
  userBreedStandardCancel(data) {//作废(养殖标准)
		return this.postFn(newApj + '/api/user/breed/standard/cancel', data)
  }
  userBreedTaskCategoryTreeAvailable(data) {//可用树结构(下拉选择使用)(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree/available', data)
  }
  userBreedTaskCategoryTreeSecondAvailable(data) {//获取二级分类(下拉选择使用)(下拉选择使用)(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree/second/available', data)
  }
  userBreedTaskCategoryTree(data) {//树结构(任务分类)
		return this.getFn(newApj + '/api/user/breed/task/category/tree', data)
  }
  userBreedTaskCategoryFirstSave(data) {//一级新增修改(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/first/save', data)
  }
  userBreedTaskCategorySecondSave(data) {//二级新增修改(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/second/save', data)
  }
  userBreedTaskCategoryDelete(data) {//删除(任务分类)
		return this.postFn(newApj + '/api/user/breed/task/category/delete', data)
  }
  userWorkflowSetList(data) {//列表查询(审批设置)
		return this.getFn(newApj + '/api/user/workflow/set/list', data)
  }
  userWorkflowSetSave(data) {//新增修改(审批设置)
		return this.postFn(newApj + '/api/user/workflow/set/save', data)
  }
  userWorkflowSetDelete(data) {//删除(审批设置)
		return this.postFn(newApj + '/api/user/workflow/set/delete', data)
  }
  userBreedTaskList(data) {//列表查询(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/list', data)
  }
  userBreedTaskCount(data) {//数量统计(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/count', data)
  }
  userBreedTaskDetail(data) {//详情(任务管理)
		return this.getFn(newApj + '/api/user/breed/task/detail', data)
  }
  userBreedTaskSave(data) {//新增修改(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/save', data)
  }
  userBreedTaskDelete(data) {//删除(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/delete', data)
  }
  userBreedTaskStart(data) {//响应(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/start', data)
  }
  userBreedTaskFocus(data) {//关注和取消关注(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/focus', data)
  }
  userBreedTaskHandle(data) {//处理(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/handle', data)
  }
  userBreedTaskAssist(data) {//协作(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/assist', data)
  }
  userBreedTaskEvaluate(data) {//评价(任务管理)
		return this.postFn(newApj + '/api/user/breed/task/evaluate', data)
  }
  userBreedParamList(data) {//列表查询(养殖参数)
		return this.getFn(newApj + '/api/user/breed/param/list', data)
  }
  userBreedParamSave(data) {//新增修改(养殖参数)
		return this.postFn(newApj + '/api/user/breed/param/save', data)
  }
  userBreedParamDelete(data) {//删除(养殖参数)
		return this.postFn(newApj + '/api/user/breed/param/delete', data)
  }
  userWorkflowList(data) {//列表查询(审批管理)
		return this.getFn(newApj + '/api/user/workflow/list', data)
  }
  userWorkflowCount(data) {//数量统计(审批管理)
		return this.getFn(newApj + '/api/user/workflow/count', data)
  }
  userWorkflowLogList(data) {//流程日志(审批管理)
		return this.getFn(newApj + '/api/user/workflow/log/list', data)
  }
  userDeviceCategoryTree(data) {//产品分类(物联网设备)
		return this.getFn(newApj + '/api/user/device/category/tree', data)
  }
  userDeviceProductList(data) {//产品分类(物联网设备)
		return this.getFn(newApj + '/api/user/device/product/list', data)
  }
  userDeviceInstanceList(data) {//物联设备列表(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/list', data)
  }
  userDeviceInstanceDetail(data) {//物联设备详情(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/detail', data)
  }
  userDeviceInstanceTagsSave(data) {//编辑设备位置(物联网设备)
		return this.postFn(newApj + '/api/user/device/instance/tags/save', data)
  }
  userDeviceInstancePropertiesLatest(data) {//获取设备最新属性值(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/properties/latest', data)
  }
  userDeviceInstancePropertyQuery(data) {//获取设备历史属性值(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/property/query', data)
  }
  userDeviceInstanceTreeCategory(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/tree/category', data)
  }
  userDeviceInstanceTreePosition(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/tree/position', data)
  }
  userDeviceInstanceCount(data) {//(物联网设备)
		return this.getFn(newApj + '/api/user/device/instance/count', data)
  }
  userVideoList(data) {//列表查询(视频监控)
		return this.getFn(newApj + '/api/user/video/list', data)
  }
  userVideoSave(data) {//新增修改(视频监控)
		return this.postFn(newApj + '/api/user/video/save', data)
  }
  userVideoDelete(data) {//删除(视频监控)
		return this.postFn(newApj + '/api/user/video/delete', data)
  }
  userVideoUrlLive(data) {//实时视频地址(视频监控)
		return this.getFn(newApj + '/api/user/video/url/live', data)
  }
  userVideoUrlBack(data) {//回放视频地址(视频监控)
		return this.getFn(newApj + '/api/user/video/url/back', data)
  }
  userKnowledgeCategoryTree(data) {//分类树(知识库)
		return this.getFn(newApj + '/api/user/knowledge/category/tree', data)
  }
  userKnowledgeCategoryTreeFirst(data) {//一级分类(知识库)
		return this.getFn(newApj + '/api/user/knowledge/category/tree/first', data)
  }
  userKnowledgeCategoryTreeSecond(data) {//二级分类(知识库)
		return this.getFn(newApj + '/api/user/knowledge/category/tree/second', data)
  }
  userKnowledgeCategorySecondSave(data) {//新增修改(知识库)
		return this.postFn(newApj + '/api/user/knowledge/category/second/save', data)
  }
  userKnowledgeCategorySecondDelete(data) {//删除(知识库)
		return this.postFn(newApj + '/api/user/knowledge/category/delete', data)
  }
  userKnowledgeArticleList(data) {//文章列表(知识库)
		return this.getFn(newApj + '/api/user/knowledge/article/list', data)
  }
  userKnowledgeArticleDetail(data) {//文章详情(知识库)
		return this.getFn(newApj + '/api/user/knowledge/article/detail', data)
  }
  userKnowledgeArticleSave(data) {//文章新增修改(知识库)
		return this.postFn(newApj + '/api/user/knowledge/article/save', data)
  }
  userKnowledgeArticleDelete(data) {//文章删除(知识库)
		return this.postFn(newApj + '/api/user/knowledge/article/delete', data)
  }
  userKnowledgeArticleFavorite(data) {//文章收藏|取消收藏(知识库)
		return this.postFn(newApj + '/api/user/knowledge/article/favorite', data)
  }
  userKnowledgeArticleFavoriteList(data) {//文章收藏列表(知识库)
		return this.getFn(newApj + '/api/user/knowledge/article/favorite/list', data)
  }
  userAiGetChatId(data) {//获取对话ID(专家在线)
		return this.getFn(newApj + '/api/user/ai/get/chatId', data)
  }
  userAiGetMessageId(data) {//获取消息ID(专家在线)
		return this.getFn(newApj + '/api/user/ai/get/messageId', data)
  }
  userAiGetExpert(data) {//获取专家号码(专家在线)
		return this.getFn(newApj + '/api/user/ai/get/expert', data)
  }
  userAiUpload(data) {//上传文件(专家在线)
		return this.uploadFn(newApj + '/api/user/ai/upload', data)
  }
  userAiList(data) {//对话记录(专家在线)
		return this.getFn(newApj + '/api/user/ai/list', data)
  }
  userAiDetail(data) {//对话详情(专家在线)
		return this.getFn(newApj + '/api/user/ai/detail', data)
  }
  userAiThumb(data) {//顶或踩(专家在线)
		return this.postFn(newApj + '/api/user/ai/thumb', data)
  }
  userAiDelete(data) {//删除(专家在线)
		return this.postFn(newApj + '/api/user/ai/delete', data)
  }
  userAiTVoice(data) {//语音合成(专家在线)
		return this.postFn(newApj + '/api/user/ai/voice', data)
  }
  userV2PsiPurchaseOrderList(data) {//采购订单(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/purchase/order/list', data)
  }
  userV2PsiPurchaseOrderDetail(data) {//采购订单(详情)
		return this.getFn(newApj + '/api/user/v2/psi/purchase/order/detail', data)
  }
  userV2PsiPurchaseOrderSave(data) {//采购订单(新增修改)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/save', data)
  }
  userV2PsiPurchaseOrderDelete(data) {//采购订单(删除)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/delete', data)
  }
  userV2PsiPurchaseOrderAudit(data) {//采购订单(审核)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/audit', data)
  }
  userV2PsiPurchaseOrderAuditEdit(data) {//采购订单(反审核)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/audit/edit', data)
  }
  userV2PsiPurchaseOrdeRreturnSave(data) {//采购退货(保存)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/return/save', data)
  }
  userV2PsiPurchaseOrdeRreturnAudit(data) {//退货审核(审核)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/order/return/audit', data)
  }
  userV2PsiPurchaseCheckList(data) {//应付款核销(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/purchase/check/list', data)
  }
  userV2PsiPurchaseCheckDetail(data) {//应付款核销(详情)
		return this.getFn(newApj + '/api/user/v2/psi/purchase/check/detail', data)
  }
  userV2PsiPurchaseCheckSave(data) {//应付款核销(核销与批量核销)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/check/save', data)
  }
  userV2PsiPurchaseCheckAudit(data) {//应付款核销(审核)
		return this.postFn(newApj + '/api/user/v2/psi/purchase/check/audit', data)
  }
  userV2PsiSaleOrderList(data) {//销售订单(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/sale/order/list', data)
  }
  userV2PsiSaleOrderDetail(data) {//销售订单(详情)
		return this.getFn(newApj + '/api/user/v2/psi/sale/order/detail', data)
  }
  userV2PsiSaleOrderSave(data) {//销售订单(新增修改)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/save', data)
  }
  userV2PsiSaleOrderDelete(data) {//销售订单(删除)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/delete', data)
  }
  userV2PsiSaleOrderAudit(data) {//销售订单(审核)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/audit', data)
  }
  userV2PsiSaleOrderAuditEdit(data) {//销售订单(反审核)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/audit/edit', data)
  }
  userV2PsiSaleOrderReturnSave(data) {//销售订单(采购退货)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/return/save', data)
  }
  userV2PsiSaleOrderReturnAudit(data) {//销售订单(退货审核)
		return this.postFn(newApj + '/api/user/v2/psi/sale/order/return/audit', data)
  }
  userV2PsiSaleCheckList(data) {//应收款核销(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/sale/check/list', data)
  }
  userV2PsiSaleCheckDetail(data) {//应收款核销(详情)
		return this.getFn(newApj + '/api/user/v2/psi/sale/check/detail', data)
  }
  userV2PsiSaleCheckSave(data) {//应收款核销(核销与批量核销)
		return this.postFn(newApj + '/api/user/v2/psi/sale/check/save', data)
  }
  userV2PsiSaleCheckAudit(data) {//应收款核销(审核)
		return this.postFn(newApj + '/api/user/v2/psi/sale/check/audit', data)
  }
  userV2PsihouseInList(data) {//入库管理(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/house/in/list', data)
  }
  userV2PsihouseInDetail(data) {//入库管理(详情)
		return this.getFn(newApj + '/api/user/v2/psi/house/in/detail', data)
  }
  userV2PsihouseInSave(data) {//入库管理(新增修改)
		return this.postFn(newApj + '/api/user/v2/psi/house/in/save', data)
  }
  userV2PsihouseInDelete(data) {//入库管理(删除)
		return this.postFn(newApj + '/api/user/v2/psi/house/in/delete', data)
  }
  userV2PsihouseInAudit(data) {//入库管理(审核)
		return this.postFn(newApj + '/api/user/v2/psi/house/in/audit', data)
  }
  userV2PsihouseInConfirm(data) {//确认入库(审核)
		return this.postFn(newApj + '/api/user/v2/psi/house/in/confirm', data)
  }
  userV2PsihouseOutList(data) {//出库管理(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/house/out/list', data)
  }
  userV2PsihouseOutDetail(data) {//出库管理(详情)
		return this.getFn(newApj + '/api/user/v2/psi/house/out/detail', data)
  }
  userV2PsihouseOutDetailConfirm(data) {//出库管理(详情-确认出库使用)
		return this.getFn(newApj + '/api/user/v2/psi/house/out/detail/confirm', data)
  }
  userV2PsihouseOutSave(data) {//出库管理(新增修改)
		return this.postFn(newApj + '/api/user/v2/psi/house/out/save', data)
  }
  userV2PsihouseOutDelete(data) {//出库管理(删除)
		return this.postFn(newApj + '/api/user/v2/psi/house/out/delete', data)
  }
  userV2PsihouseOutAudit(data) {//出库管理(审核)
		return this.postFn(newApj + '/api/user/v2/psi/house/out/audit', data)
  }
  userV2PsihouseOutConfirm(data) {//出库管理(确认出库)
		return this.postFn(newApj + '/api/user/v2/psi/house/out/confirm', data)
  }
  userV2PsiStockList(data) {//库存查询
		return this.getFn(newApj + '/api/user/v2/psi/stock/list', data)
  }
  userV2PsiStockLog(data) {//库存日志
		return this.getFn(newApj + '/api/user/v2/psi/stock/log', data)
  }
  userV2PsiHouseExchangeList(data) {//调拨管理(列表查询)
		return this.getFn(newApj + '/api/user/v2/psi/house/exchange/list', data)
  }
  userV2PsiHouseExchangeDetail(data) {//调拨管理(详情)
		return this.getFn(newApj + '/api/user/v2/psi/house/exchange/detail', data)
  }
  userV2PsiHouseExchangeSave(data) {//调拨管理(新增修改)
		return this.postFn(newApj + '/api/user/v2/psi/house/exchange/save', data)
  }
  userV2PsiHouseExchangeDelete(data) {//调拨管理(删除)
		return this.postFn(newApj + '/api/user/v2/psi/house/exchange/delete', data)
  }
  userV2PsiHouseExchangeAudit(data) {//调拨管理(审核)
		return this.postFn(newApj + '/api/user/v2/psi/house/exchange/audit', data)
  }
  userV2PsiStockReport1(data) {//采购统计
		return this.getFn(newApj + '/api/user/v2/psi/stock/report1', data)
  }
  userV2PsiStockReport2(data) {//销售统计
		return this.getFn(newApj + '/api/user/v2/psi/stock/report2', data)
  }
  userV2PsiStockReport3(data) {//入库明细
		return this.getFn(newApj + '/api/user/v2/psi/stock/report3', data)
  }
  userV2PsiStockReport4(data) {//出库明细
		return this.getFn(newApj + '/api/user/v2/psi/stock/report4', data)
  }
  userV2PsiStockReport5(data) {//调拨明细
		return this.getFn(newApj + '/api/user/v2/psi/stock/report5', data)
  }
  userV2PsiStockReport6(data) {//入库汇总
		return this.getFn(newApj + '/api/user/v2/psi/stock/report6', data)
  }
  userV2PsiStockReport7(data) {//出库汇总
		return this.getFn(newApj + '/api/user/v2/psi/stock/report7', data)
  }
  userManageHousePenVedioList(data) {//出库汇总
		return this.getFn(newApj + '/api/user/manage/house/pen/vedio/list', data)
  }
  

	postFn (url,data) {
    return Vue.http.post(url, data,{
      headers: {
        "Authorization": state.token,
      },
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      _this.$message.error(data.body.msg);
    }
    return data
    }).catch((err) => {})
  }
  getFn (url,data) {
    return Vue.http.get(url, {
      params: data,
      headers: { "Authorization": state.token }
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      if(data.body.code !== 401){
        _this.$message.error(data.body.msg);
      }
    }
    return data
    }).catch((err) => {})
  }
  uploadFn (url,data) {
    return Vue.http.post(url, data,{
      headers: {
        "Content-Type": 'multipart/form-data',
        "Authorization": state.token,
      },
    }).then(data => {
    state.loading =  false;
    if(data.body.code === 401 && _this.$route.path != '/login'){
      _this.$store.state.token = '';
      localStorage.removeItem('SHANGYI_TOKEN');
      _this.$router.push('/login')
    }else if(data.body.code !== 200){
      if(data.body.code !== 401){
        _this.$message.error(data.body.msg);
      }
    }
    return data
    }).catch((err) => {})
  }
  
}

export default new BaseModule()



// WEBPACK FOOTER //
// ./src/api/index.js